import { render, staticRenderFns } from "./ContactGroups.vue?vue&type=template&id=1f189098&"
import script from "./ContactGroups.vue?vue&type=script&lang=js&"
export * from "./ContactGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports